(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/hooks/use-trixa.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/hooks/use-trixa.js');

'use strict';

const {
  useCallback,
  useState
} = React;
const {
  Trixa
} = svs.components.marketplaceCompetition.overviewHero.common;

const useTrixa = () => {
  const [visible, setVisible] = useState(false);
  const showGame = useCallback(() => {
    setVisible(true);
  }, []);
  return [showGame, visible ? Trixa : undefined];
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.hooks.useTrixa', useTrixa);

 })(window);